import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { ConfigService } from 'app/services';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'report-disbursements',
    templateUrl: './report-disbursements.component.html',
    styleUrls: ['./report-disbursements.component.scss'],
    providers: [MessageService]
})
export class ReportDisbursementsComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    public xpressReportDisbursements: Array<any> = [];

    public selectedDisbursement: any = undefined;
    public cols: any[] = [
        { field: 'Dispursement ID', header: 'Dispursement ID', width: '90px', isLink: false },
        { field: 'Earning Period', header: 'Earning Period', width: '350px', isLink: false },
        { field: 'Payout Date:', header: 'Payout Date:', width: '350px' },
        { field: 'Partners', header: 'Partners' },
        { field: 'Payout Channel', header: 'Payout Channel', width: '100px' },
        { field: 'Value', header: 'Value', width: '100px', disableSort: true }
    ];
    public defaultCols = this.cols.map(x => x);

    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    public tableName: string = 'report-disbursements';

    private sortOrder: number = 1;

    public filter: { searchName: string } = { searchName: ''};

    public loading: boolean = true;

    private searchTimer: number = 0;

    public visibleReportDisbursementsFilter: boolean = false;
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_reports' }, { label: 'Reports' }, { label: 'Disbursements' }];

    constructor(public configService: ConfigService) { }

    ngOnInit(): void { }

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.tableName);
        }

        this.getXpressReportDisbursements(skip);
    }

    public getXpressReportDisbursements(skip: number) { }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getXpressReportDisbursements(0);
            this.searchTimer = 0;
        }, 1500);
    }

    onSelectedColumnsChange(event: any) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }
    }
}
